import TakeBackBagDetails from './TakeBackBagDetails';

export default TakeBackBagDetails;
